import { render, staticRenderFns } from "./ZNSReconcile.vue?vue&type=template&id=620c3e8a&scoped=true"
import script from "./ZNSReconcile.vue?vue&type=script&lang=js"
export * from "./ZNSReconcile.vue?vue&type=script&lang=js"
import style0 from "./ZNSReconcile.vue?vue&type=style&index=0&id=620c3e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620c3e8a",
  null
  
)

export default component.exports